export default class User {
  constructor (user) {
    this.login = user ? user.login : ''
    this.password = user ? user.password : ''
  }
}
